module.exports = __webpack_public_path__ + "img/bike-fail.7d4224bd.svg";